/**
 * UA_TABLET モジュール
 * - ユーザーエージェントからタブレット端末を判定し、viewportメタタグを強制的に1280pxに変更
 */
export const UA_TABLET = {
  /**
   * 初期化関数：iPad または Androidタブレットの場合に viewport を上書き
   */
  init() {
    const ua = navigator.userAgent.toLowerCase()
    if (this.isIpad(ua) || this.isAndroidTablet(ua)) {
      const viewportMeta = document.querySelector('meta[name="viewport"]')
      if (viewportMeta) {
        viewportMeta.setAttribute('content', 'width=1280px')
      }
    }
  },

  /**
   * iPad 判定
   * @param {string} ua - ユーザーエージェント文字列
   * @returns {boolean}
   */
  isIpad(ua) {
    return ua.includes('ipad')
  },

  /**
   * Androidタブレット 判定
   * - "android" を含み、かつ "mobile" を含まない
   * @param {string} ua - ユーザーエージェント文字列
   * @returns {boolean}
   */
  isAndroidTablet(ua) {
    return ua.includes('android') && !ua.includes('mobile')
  },
}
